import React from 'react';

// import PropTypes from 'prop-types';

// import * as am4core from '@amcharts/amcharts4/core';
// import * as am4charts from '@amcharts/amcharts4/charts';
// import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import { pieChartWidget as PieChartWidgetView } from 'ui/views/widgets/pieChartWidget';

// am4core.useTheme( am4themes_animated );

// React view component to render
// import { someView as SomeView } from 'views/someView';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { PieChartWidget } from 'ui/containers/PieChartWidget';
 *
 * // render
 * <PieChartWidget propName='propValue'/>
 */
export class PieChartWidget extends React.Component {

	/**
	 * @param {object} props - props
	 */
	constructor( props ) {
        super( props );
        
    }

	// componentDidMount() {
        
	// 	const chart = am4core.create( 'chartdiv', am4charts.PieChart );

	// 	// Add data
	// 	chart.data = this.props.data;

	// 	// Add and configure Series
	// 	const pieSeries = chart.series.push( new am4charts.PieSeries() );
	// 	pieSeries.dataFields.value = 'litres';
	// 	pieSeries.dataFields.category = 'country';

	// 	chart.radius = am4core.percent( 95 );

	// 	// Create custom legend
	// 	chart.events.on( 'ready', () => {

	// 		// populate our custom legend when chart renders
	// 		chart.customLegend = document.getElementById( 'legend' );
	// 		pieSeries.dataItems.each( function ( row, i ) {
	// 			const color = chart.colors.getIndex( i );
	// 			const percent = Math.round( row.values.value.percent * 100 ) / 100;
	// 			const value = row.value;

	// 			legend.innerHTML =
	// 				legend.innerHTML +
	// 				( '<div class="legend-item" id="legend-item-' +
	// 					i +
	// 					'" onclick="toggleSlice(' +
	// 					i +
	// 					');" onmouseover="hoverSlice(' +
	// 					i +
	// 					');" onmouseout="blurSlice(' +
	// 					i +
	// 					');" ><div class="legend-marker" style="background: ' +
	// 					color +
	// 					'"></div>' +
	// 					row.category +
	// 					'<div class="legend-value">' +
	// 					value +
	// 					' | ' +
	// 					percent +
	// 					'%</div></div>' );
	// 		} );
	// 	} );

	// 	this.chart = chart;
	// }

	// toggleSlice( item ) {
    //     const slice = pieSeries.dataItems.getIndex( item );
    //     if ( slice.visible ) {
    //         slice.hide();
    //     } else {
    //         slice.show();
    //     }
    // }

	//    hoverSlice( item ) {
	//     const slice = pieSeries.slices.getIndex( item );
	//     slice.isHover = true;
	//   }

	//    blurSlice( item ) {
	//     const slice = pieSeries.slices.getIndex( item );
	//     slice.isHover = false;
	//   }

	// componentWillUnmount() {
	// 	if ( this.chart ) {
	// 		this.chart.dispose();
	// 	}
	// }

	render() {
		return <PieChartWidgetView { ...this.props }/>;
	}
}

// set display name
PieChartWidget.displayName = 'PieChartWidget';

// set default props
PieChartWidget.defaultProps = {};

// prop types
PieChartWidget.propTypes = {};
